import parse from "html-react-parser";

export function ProseHtml({ html }: { html?: string }) {
  return (
    <div
      className="prose
              prose-headings:font-bold prose-headings:text-gray-900
              prose-h1:text-4xl
              prose-h2:text-3xl
              prose-h3:text-[22px]
              prose-h4:text-xl
              prose-h5:text-lg
              prose-p:text-[15px] prose-p:text-gray-800 prose-p:my-1
              prose-strong:font-bold
              prose-li:text-[15px] prose-li:text-gray-800
              prose-ol:text-[15px] prose-ol:text-gray-800
              prose-ul:text-[15px] prose-ul:text-gray-800
              prose-a:text-primary prose-a:hover:text-primary-active
              prose-table:text-[15px] prose-table:text-gray-800 prose-table:border prose-table:border-gray-800
              prose-th:text-[15px] prose-th:text-gray-800 prose-th:font-bold prose-th:border prose-th:border-gray-800
              prose-td:text-[15px] prose-td:text-gray-800 prose-td:px-1 prose-td:border prose-td:border-gray-800
              prose-tr:text-[15px] prose-tr:text-gray-800 prose-tr:border prose-tr:border-gray-800"
    >
      {parse(html ?? "")}
    </div>
  );
}
